import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../services/api';
import './Login.css';
import logger from '../utils/logger';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.requestPasswordReset(email);
      setSuccess(true);
    } catch (err) {
      logger.error('Erreur lors de la demande de réinitialisation:', err);
      setError(
        err.response?.data?.error ||
        err.response?.data?.message ||
        'Une erreur est survenue. Veuillez réessayer.'
      );
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-page">
        <nav className="auth-navbar">
          <div className="auth-nav-container">
            <Link to="/" className="auth-nav-logo">
              <img src="/images/logo_transparent.png" alt="Crions D'Couleurs" className="logo-img" />
              <span className="logo-text">Crions D'Couleurs</span>
            </Link>

            <div className="auth-nav-menu">
              <Link to="/" className="auth-nav-link">Accueil</Link>
              <Link to="/sejours" className="auth-nav-link">Séjours</Link>
              <Link to="/login" className="auth-nav-btn">Se connecter</Link>
            </div>
          </div>
        </nav>

        <div className="auth-container">
          <div className="auth-card">
            <div className="auth-header">
              <h1 className="auth-title">Email envoyé</h1>
            </div>

            <div className="text-center" style={{ padding: '1rem 0' }}>
              <svg
                className="w-16 h-16 mx-auto mb-4 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                style={{ width: '4rem', height: '4rem', margin: '0 auto 1rem' }}
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p className="text-gray-700 mb-4" style={{ fontSize: '0.95rem', lineHeight: '1.6', marginBottom: '1rem' }}>
                Si un compte existe avec l'adresse <strong>{email}</strong>,
                vous recevrez un email avec les instructions pour réinitialiser votre mot de passe.
              </p>
              <p className="text-gray-500" style={{ fontSize: '0.875rem' }}>
                Vérifiez également votre dossier spam.
              </p>
            </div>

            <Link to="/login" className="auth-button" style={{ display: 'block', textAlign: 'center', marginTop: '1.5rem' }}>
              Retour à la connexion
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <nav className="auth-navbar">
        <div className="auth-nav-container">
          <Link to="/" className="auth-nav-logo">
            <img src="/images/logo_transparent.png" alt="Crions D'Couleurs" className="logo-img" />
            <span className="logo-text">Crions D'Couleurs</span>
          </Link>

          <div className="auth-nav-menu">
            <Link to="/" className="auth-nav-link">Accueil</Link>
            <Link to="/sejours" className="auth-nav-link">Séjours</Link>
            <Link to="/login" className="auth-nav-btn">Se connecter</Link>
          </div>
        </div>
      </nav>

      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-title">Mot de passe oublié</h1>
            <p className="auth-subtitle">
              Entrez votre adresse email pour recevoir un lien de réinitialisation
            </p>
          </div>

          <form className="auth-form" onSubmit={handleSubmit}>
            {error && (
              <div className="auth-error">
                {error}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Adresse email
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.com"
                required
                disabled={loading}
                className="form-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="auth-button"
            >
              {loading ? 'Envoi en cours...' : 'Envoyer le lien de réinitialisation'}
            </button>

            <div className="auth-footer">
              <p className="auth-footer-text">
                <Link to="/login" className="auth-footer-link">
                  Retour à la connexion
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
